/**
 * Apple Watch アコーディオン / 漆チェック用スクリプト
 *
 * SC Product Options (Bold Options) が .bold_options に注入するラジオ選択肢と、
 * UI の .apple-watch-accordion を連携させる。
 * - アダプター選択肢の件数・文言を Bold Options から生成し、アコーディオン内は dropdown で表示
 * - アダプター価格は選択肢が選ばれたときだけ見出し横に表示
 * - Bold Options 側のアダプター radio UI は視覚的に隠す（値の保持・連動・価格計算用に DOM は残す）
 * - アコーディオンの開閉・選択 UI
 * - アコーディオンの dropdown 選択 → Bold Options の radio 連動
 * - ベルトサイズは現在のサイズを初期選択。他サイズは metafield の商品ページへリンク遷移
 * - 選択に合わせて bold_option_price_display（バックルのみ）/ 合計価格（アダプター込み）も更新
 * - 漆チェックがある場合、カート投入前に確認モーダルを出す
 * - カート投入の二重送信防止（見た目は変えず、2回目以降の submit/click を止める）
 */
(function () {
  'use strict'

  // Bold Options 側でアダプター用オプションを特定するためのタイトル判定
  var ADAPTER_TITLE_RE = /アップルウォッチ|アダプタ|Apple Watch/i
  // Bold Options 側でバックル見出し（.bold_option_top）を出すためのタイトル判定
  var BUCKLE_TITLE_RE = /バックル|Dバックル/
  // Bold Options 側で漆チェック用オプションを特定するためのタイトル判定
  var URUSHI_TITLE_RE = /漆/
  // Bold Options のアダプター radio を視覚的に隠すためのクラス
  var HIDDEN_ADAPTER_CLASS = 'is-hidden-by-apple-watch-accordion'
  // ベルト幅の他サイズリンクから付与するクエリ
  // 例: /products/xxx?aw_accordion=open
  var ACCORDION_OPEN_QUERY_KEY = 'aw_accordion'
  var ACCORDION_OPEN_QUERY_VALUE = 'open'

  function addAccordionOpenQuery(href) {
    try {
      var url = new URL(href, window.location.origin)
      url.searchParams.set(ACCORDION_OPEN_QUERY_KEY, ACCORDION_OPEN_QUERY_VALUE)
      return url.toString()
    } catch (e) {
      var separator = String(href).indexOf('?') === -1 ? '?' : '&'
      return href + separator + ACCORDION_OPEN_QUERY_KEY + '=' + ACCORDION_OPEN_QUERY_VALUE
    }
  }

  function shouldOpenAccordionFromQuery() {
    try {
      return new URLSearchParams(window.location.search).get(ACCORDION_OPEN_QUERY_KEY) === ACCORDION_OPEN_QUERY_VALUE
    } catch (e) {
      return false
    }
  }

  /**
   * カート投入を1回だけ通すガード
   * disabled 等の見た目変更はしない
   *
   * 注意:
   * - 初回 click でフラグを立てたあと submit まで止めると、正規の送信も落ちる
   * - SC Product Options は .bold_clone クリック後に .bold_hidden を踏むため、
   *   .bold_hidden の click は止めない
   * - 必須未選択などで送信に失敗した場合はロックを解除し、再試行できるようにする
   */
  function guardFormSubmitOnce(form) {
    if (!form || form.dataset.submitGuarded === 'true') return
    form.dataset.submitGuarded = 'true'

    var isSubmitting = false

    function unlockSubmit() {
      isSubmitting = false
    }

    function hasBoldError() {
      if (form.querySelector('.bold_error_message')) return true
      var modal = document.querySelector('.js-urushi-check-modal')
      return !!(modal && modal.querySelector('.bold_error_message'))
    }

    form.__unlockStrapSubmit = unlockSubmit

    // スティッキーバーの「カートに入れる」も漆チェックモーダルを出す
    document.addEventListener(
      'click',
      function (event) {
        var stickySubmit = event.target.closest('.js-product-sticky-bar-submit')
        if (!stickySubmit || stickySubmit.disabled) return

        if (
          form.dataset.urushiCheckReady === 'true' &&
          form.dataset.urushiConfirmed !== 'true'
        ) {
          event.preventDefault()
          event.stopImmediatePropagation()
          setUrushiModalOpen(form, true)
        }
      },
      true
    )

    // bold_clone など後から生える submit ボタンにも効くよう委譲する
    form.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(
          'button[type="submit"], input[type="submit"], .product-form__submit'
        )
        if (!button || !form.contains(button)) return

        // アプリが本体ボタンをプログラムから踏む分は通す
        if (button.classList.contains('bold_hidden')) return

        // 漆チェックがある場合、カートに入れるは確認モーダルを開くだけ
        if (
          form.dataset.urushiCheckReady === 'true' &&
          form.dataset.urushiConfirmed !== 'true' &&
          !button.classList.contains('js-urushi-check-submit')
        ) {
          event.preventDefault()
          event.stopImmediatePropagation()
          setUrushiModalOpen(form, true)
          return
        }

        if (isSubmitting) {
          event.preventDefault()
          event.stopImmediatePropagation()
          return
        }

        isSubmitting = true

        // 必須エラー等でページ遷移しない場合、エラー表示を待ってロック解除
        setTimeout(function () {
          if (hasBoldError()) {
            unlockSubmit()
          }
        }, 100)
      },
      true
    )

    // オプションを選び直したら再送信できるようロック解除
    // 漆チェックはモーダルへ移すため document でも拾う
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target
        if (!target.closest || !target.closest('.bold_option')) return
        if (form.contains(target)) {
          unlockSubmit()
          return
        }
        var modal = getUrushiModal(form)
        if (modal && modal.contains(target)) {
          unlockSubmit()
        }
      },
      true
    )

    // アプリが非同期でエラー文言を差し込むケースにも備える
    var errorRoots = [form.querySelector('.bold_options'), document.body]
    errorRoots.forEach(function (root) {
      if (!root) return
      var errorObserver = new MutationObserver(function () {
        if (isSubmitting && hasBoldError()) {
          unlockSubmit()
        }
      })
      errorObserver.observe(root, { childList: true, subtree: true })
    })
  }
  /**
   * form 内から漆チェック用の .bold_option_set を返す
   * @returns {Element|null}
   */
  function findUrushiOptionSet(form) {
    var scope = form || document
    var options = scope.querySelectorAll('.bold_option')

    for (var i = 0; i < options.length; i++) {
      var titleEl = options[i].querySelector('.bold_option_title')
      var title = titleEl ? titleEl.textContent.trim() : ''
      if (URUSHI_TITLE_RE.test(title)) {
        return options[i].closest('.bold_option_set') || options[i]
      }
    }

    return null
  }

  function ensureUrushiHeading(optionSet) {
    var checkbox = optionSet && optionSet.querySelector('.bold_option_checkboxmulti')
    if (!checkbox) return

    var existing = checkbox.querySelectorAll('.checkbtn-heading')
    if (existing.length) {
      for (var i = 1; i < existing.length; i++) {
        existing[i].parentNode.removeChild(existing[i])
      }
      return
    }

    var heading = document.createElement('p')
    heading.className = 'checkbtn-heading'
    heading.innerHTML =
      '必ずご確認ください<span>姫路黒桟革ストラップには漆が使われております。漆は室（ムロ）にて完全に乾燥させていますので、漆によるかぶれはほとんどありませんが、体質等により、かぶれが生じることがあります。その場合は使用を中止して、医師にご相談下さい。</span>'
    checkbox.insertBefore(heading, checkbox.firstChild)
  }

  function getUrushiModal(form) {
    if (form) {
      var nested = form.querySelector('.js-urushi-check-modal')
      if (nested) return nested
      if (form.id) {
        return document.querySelector('.js-urushi-check-modal[data-urushi-form-id="' + form.id + '"]')
      }
    }
    return document.querySelector('.js-urushi-check-modal')
  }

  function setUrushiModalOpen(form, isOpen) {
    var modal = getUrushiModal(form)
    if (!modal) return

    modal.hidden = !isOpen
    modal.classList.toggle('is-open', isOpen)
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
    document.body.classList.toggle('urushi-check-modal-open', isOpen)

    if (isOpen) {
      var dialog = modal.querySelector('.urushi-check-modal__dialog')
      if (dialog) dialog.focus()
    } else {
      form.dataset.urushiConfirmed = 'false'
    }
  }

  /**
   * 漆チェックの option_set をモーダルへ移し、カート投入を二段階にする
   * @returns {boolean} セットできた、または漆チェックが無いと確定した場合 true
   */
  function setupUrushiCheckModal(form) {
    if (!form || form.dataset.urushiCheckReady === 'true') return true

    var optionSet = findUrushiOptionSet(form)
    if (!optionSet) return false

    var boldOptions = form.querySelector('.bold_options')
    if (!boldOptions) return false

    var modal = document.createElement('div')
    modal.className = 'urushi-check-modal js-urushi-check-modal'
    modal.hidden = true
    if (form.id) modal.setAttribute('data-urushi-form-id', form.id)
    modal.innerHTML =
      '<div class="urushi-check-modal__overlay js-urushi-check-modal-overlay"></div>' +
      '<div class="urushi-check-modal__dialog" role="dialog" aria-modal="true" aria-label="漆についての確認" tabindex="-1">' +
      '<button type="button" class="urushi-check-modal__close js-urushi-check-modal-close" aria-label="閉じる"></button>' +
      '<div class="urushi-check-modal__body js-urushi-check-modal-body"></div>' +
      '<button type="button" class="urushi-check-modal__submit js-urushi-check-submit">ご購入の手続き</button>' +
      '</div>'

    var body = modal.querySelector('.js-urushi-check-modal-body')
    body.appendChild(optionSet)
    if (form.id) {
      optionSet.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.setAttribute('form', form.id)
      })
    }
    document.body.appendChild(modal)
    ensureUrushiHeading(optionSet)

    function closeModal() {
      setUrushiModalOpen(form, false)
    }

    modal.querySelector('.js-urushi-check-modal-overlay').addEventListener('click', closeModal)
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal()
    })
    modal.querySelector('.js-urushi-check-modal-close').addEventListener('click', closeModal)

    modal.querySelector('.js-urushi-check-submit').addEventListener('click', function () {
      form.dataset.urushiConfirmed = 'true'
      // 必須エラー後の再試行では、前回の送信ロックを解除してからカート投入する
      if (typeof form.__unlockStrapSubmit === 'function') {
        form.__unlockStrapSubmit()
      }
      var submit =
        form.querySelector('.product-form__submit.bold_clone') ||
        form.querySelector('.product-form__submit:not(.bold_hidden)')
      if (submit) submit.click()
    })

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal()
      }
    })

    document.addEventListener('cart:updated', closeModal)
    document.addEventListener('cart:update', closeModal)

    form.dataset.urushiCheckReady = 'true'
    form.dataset.urushiConfirmed = 'false'
    return true
  }

  /**
   * Bold Options 注入後に漆チェックがあればモーダル化する
   */
  function watchUrushiCheck(form) {
    if (!form || form.dataset.urushiWatching === 'true') return
    form.dataset.urushiWatching = 'true'

    if (setupUrushiCheckModal(form)) return

    var boldOptions = form.querySelector('.bold_options')
    if (!boldOptions) return

    var observer = new MutationObserver(function () {
      if (setupUrushiCheckModal(form)) {
        observer.disconnect()
        return
      }
      // オプション注入が終わっていて漆が無い場合は監視を終える
      if (form.querySelector('.bold_option_total') && !findUrushiOptionSet(form)) {
        observer.disconnect()
      }
    })

    observer.observe(boldOptions, { childList: true, subtree: true })
  }

  /**
   * form 内からアダプター用の .bold_option_radio 要素を1つ返す
   * @returns {Element|null}
   */
  function findAdapterRadioGroup(form) {
    var scope = form || document
    var radios = scope.querySelectorAll('.bold_option.bold_option_radio')

    for (var i = 0; i < radios.length; i++) {
      var titleEl = radios[i].querySelector('.bold_option_title')
      var title = titleEl ? titleEl.textContent.trim() : ''
      // バックルなど他のラジオはスキップし、アダプター用だけ対象にする
      if (ADAPTER_TITLE_RE.test(title)) return radios[i]
    }

    return null
  }

  /**
   * form 内の Bold Options から、アダプター用ラジオの一覧を取得する
   * @returns {{ text: string, input: HTMLInputElement, price: number }[]}
   */
  function getAdapterOptions(form) {
    var radioGroup = findAdapterRadioGroup(form)
    var options = []
    if (!radioGroup) return options

    radioGroup.querySelectorAll('.bold_option_value').forEach(function (valueEl) {
      var input = valueEl.querySelector('.bold_option_value_element input')
      var titleSpan = valueEl.querySelector('.bold_option_value_title')
      var priceEl = valueEl.querySelector('.bold_option_value_price')
      var text = ''

      // 送信値 (input.value) を優先。なければ表示用タイトルを使う
      if (input && input.value) {
        text = input.value.trim()
      } else if (titleSpan) {
        text = titleSpan.textContent.trim()
      }

      if (text && input) {
        options.push({
          text: text,
          input: input,
          price: priceEl ? parseYenAmount(priceEl.textContent) : 0
        })
      }
    })

    return options
  }

  /**
   * 見出し横のアダプター価格を、選択中オプションの金額にする
   * 未選択・価格0（なし）のときは空にして非表示にする
   */
  function updateAdapterPriceDisplay(group, price) {
    if (!group) return
    var priceEl =
      group.querySelector('.js-apple-watch-adapter-price') ||
      group.querySelector('.apple-watch-accordion__adapter-price')
    if (!priceEl) return

    var amount = typeof price === 'number' ? price : parseYenAmount(price)
    priceEl.textContent = amount ? '¥' + amount.toLocaleString('ja-JP') : ''
  }

  /**
   * Bold Options 側のアダプター radio UI を非表示にする
   * input 自体は残すので、アコーディオンからの選択・カート送信は可能
   */
  function hideAdapterBoldOption(form) {
    var radioGroup = findAdapterRadioGroup(form)
    if (radioGroup) {
      radioGroup.classList.add(HIDDEN_ADAPTER_CLASS)
    }
  }

  /**
   * 「¥1,100」や「+1100」などの価格テキストを数値にする
   */
  function parseYenAmount(text) {
    var cleaned = String(text || '').replace(/[¥￥,\s]/g, '')
    var sign = 1
    if (cleaned.indexOf('-') === 0) {
      sign = -1
      cleaned = cleaned.slice(1)
    } else if (cleaned.indexOf('+') === 0) {
      cleaned = cleaned.slice(1)
    }
    var n = parseInt(cleaned, 10)
    return isNaN(n) ? 0 : n * sign
  }

  /**
   * 選択中の Bold Options（radio / checkbox）の .bold_option_value_price を合算する
   * excludeAdapter が true のときはバックルなどアダプター以外だけ合算する
   */
  function getCheckedOptionsPrice(form, excludeAdapter) {
    var scope = form || document
    var total = 0

    scope.querySelectorAll('.bold_option_value').forEach(function (valueEl) {
      var input = valueEl.querySelector('input[type="radio"], input[type="checkbox"]')
      if (!input || !input.checked) return

      if (excludeAdapter) {
        var optionEl = valueEl.closest('.bold_option')
        var titleEl = optionEl && optionEl.querySelector('.bold_option_title')
        var title = titleEl ? titleEl.textContent.trim() : ''
        if (ADAPTER_TITLE_RE.test(title)) return
      }

      var priceEl = valueEl.querySelector('.bold_option_value_price')
      if (!priceEl) return

      total += parseYenAmount(priceEl.textContent)
    })

    return total
  }

  /**
   * bold_option_price_display と product-form__total-price を、選択中オプション価格で更新する
   * 表示はバックルのみ、合計はアダプター込み。SC Product Options が click に反応しない場合のフォールバック
   */
  function syncPriceDisplaysFromCheckedOptions(form) {
    var scope = form || document
    var bucklePrice = getCheckedOptionsPrice(scope, true)
    var optionPrice = getCheckedOptionsPrice(scope)

    var display = scope.querySelector('.bold_option_price_display')
    if (display) {
      var span = display.querySelector('span')
      if (!span) {
        span = document.createElement('span')
        display.appendChild(span)
      }
      // buy-buttons-strap.liquid 側の表示形式（¥550）に合わせる
      span.textContent = bucklePrice ? '¥' + bucklePrice.toLocaleString('ja-JP') : ''
    }

    var totalEl =
      scope.querySelector('.product-form__total-price') ||
      document.querySelector('.product-form__total-price')
    if (totalEl) {
      var basePrice = parseInt(totalEl.getAttribute('data-base-price'), 10) || 0
      var valueEl = totalEl.querySelector('.product-form__total-price-value')
      if (valueEl) {
        valueEl.textContent = '¥' + (basePrice + optionPrice).toLocaleString('ja-JP')
      }
    }
  }

  /**
   * アコーディオンで選んだ値に対応する Bold Options の radio を選択する
   * SC Product Options はユーザー click で価格再計算するため、label/input を click する
   */
  function selectAdapterRadio(form, value) {
    if (!value) {
      clearAdapterRadio(form)
      return
    }

    var options = getAdapterOptions(form)
    for (var i = 0; i < options.length; i++) {
      if (options[i].text !== value) continue

      var input = options[i].input
      if (input.checked) {
        // 同じ項目の再クリックでも表示を揃えておく
        syncPriceDisplaysFromCheckedOptions(form)
        return
      }

      // 実クリックに近い操作でアプリ側の価格計算を動かす
      var label = input.closest('label')
      if (label) {
        label.click()
      } else {
        input.click()
      }

      // アプリ更新が遅い / 来ない場合に備え、選択中オプション価格で表示を同期
      setTimeout(function () {
        syncPriceDisplaysFromCheckedOptions(form)
      }, 50)
      return
    }
  }

  /**
   * アコーディオンの dropdown が未選択に戻ったとき、Bold Options のアダプター radio を外す
   */
  function clearAdapterRadio(form) {
    var options = getAdapterOptions(form)
    for (var i = 0; i < options.length; i++) {
      var input = options[i].input
      if (input && input.checked) {
        input.checked = false
      }
    }
    syncPriceDisplaysFromCheckedOptions(form)
  }

  /**
   * ベルト幅のクリックをバインドする
   * is-selected はページ読み込み時の付与のみ残し、クリックでは付け替えない
   * 他サイズは商品ページへ遷移し、アコーディオンを開くクエリを付ける
   */
  function bindBeltChoices(root) {
    var group = root.querySelector('[data-option-group="belt-size"]')
    if (!group) return

    var label = group.querySelector('.js-apple-watch-selected-label')
    var choices = group.querySelectorAll('.js-apple-watch-belt-choice')

    choices.forEach(function (choice) {
      if (choice.dataset.bound === 'true') return
      choice.dataset.bound = 'true'

      choice.addEventListener('click', function (event) {
        var value = choice.getAttribute('data-value') || choice.textContent.trim()
        if (label) {
          label.textContent = value
        }

        if (choice.tagName !== 'A') return
        var href = choice.getAttribute('href') || choice.href
        if (!href) return
        event.preventDefault()
        window.location.href = addAccordionOpenQuery(href)
      })
    })
  }

  /**
   * Apple Watch（アダプター）の dropdown をバインドする
   * 選択で見出し・価格を更新し、Bold Options の radio と連動する
   */
  function bindAdapterSelect(group) {
    var select = group.querySelector('.js-apple-watch-adapter-select')
    if (!select || select.dataset.bound === 'true') return
    select.dataset.bound = 'true'

    var label = group.querySelector('.js-apple-watch-selected-label')
    var form = group.closest('form') || document

    select.addEventListener('change', function () {
      var value = select.value
      var selectedOption = select.options[select.selectedIndex]
      var price = selectedOption ? parseYenAmount(selectedOption.getAttribute('data-price')) : 0

      if (label) {
        label.textContent = value || 'Apple Watch アダプターを選ぶ'
      }
      updateAdapterPriceDisplay(group, price)
      selectAdapterRadio(form, value)
    })
  }

  /**
   * アダプター以外の .bold_option_radio について、最初の選択肢を初期クリックする
   * Bold Options が注入済みの状態で呼ぶこと
   */
  function selectFirstNonAdapterOptions(form) {
    var scope = form || document
    scope.querySelectorAll('.bold_option.bold_option_radio').forEach(function (radioGroup) {
      var titleEl = radioGroup.querySelector('.bold_option_title')
      var title = titleEl ? titleEl.textContent.trim() : ''
      // アダプター用はスキップ（アコーディオン側で初期選択する）
      if (ADAPTER_TITLE_RE.test(title)) return

      var firstLabel = radioGroup.querySelector('.bold_option_value label')
      if (firstLabel) firstLabel.click()
    })
  }

  /**
   * Bold Options のアダプター選択肢を元に、アコーディオン内の dropdown を再生成する
   * @returns {boolean} 同期できた場合 true（監視の解除判定に使う）
   */
  function syncAdapterChoices(root) {
    var form = root.closest('form') || document
    var options = getAdapterOptions(form)
    // まだアプリがオプションを注入していない場合は失敗扱い
    if (!options.length) return false

    // アコーディオンに置き換えるため、元の radio UI は隠す
    hideAdapterBoldOption(form)

    // アダプター以外の radio（バックルなど）の最初の選択肢を初期選択
    selectFirstNonAdapterOptions(form)

    var adapterGroup = root.querySelector('[data-option-group="adapter"]')
    if (!adapterGroup) return false

    var container = adapterGroup.querySelector('.apple-watch-accordion__choices')
    if (!container) return false

    container.classList.remove('apple-watch-accordion__choices--stack')
    container.classList.add('apple-watch-accordion__choices--dropdown')
    container.innerHTML = ''

    var wrap = document.createElement('div')
    wrap.className = 'apple-watch-accordion__adapter-dropdown'

    var select = document.createElement('select')
    select.className = 'apple-watch-accordion__adapter-select js-apple-watch-adapter-select'
    select.setAttribute('aria-label', 'Apple Watch アダプター')

    var placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.textContent = 'Apple Watch アダプターを選ぶ'
    select.appendChild(placeholder)

    options.forEach(function (option) {
      var opt = document.createElement('option')
      opt.value = option.text
      opt.textContent = option.text
      opt.setAttribute('data-price', String(option.price || 0))
      select.appendChild(opt)
    })

    wrap.appendChild(select)
    container.appendChild(wrap)

    // 選択肢が差し替わったので選択表示・価格を初期化
    var selectedLabel = adapterGroup.querySelector('.js-apple-watch-selected-label')
    if (selectedLabel) selectedLabel.textContent = 'Apple Watch アダプターを選ぶ'
    updateAdapterPriceDisplay(adapterGroup, 0)

    bindAdapterSelect(adapterGroup)
    root.classList.add('is-ready')
    return true
  }

  /**
   * Bold Options の注入が完了したかどうか
   * アダプターが無い商品で監視を終える判定に使う
   */
  function isBoldOptionsSettled(form) {
    var boldOptions = form && form.querySelector('.bold_options')
    if (!boldOptions) return false
    if (boldOptions.classList.contains('bold_options_loaded')) return true
    if (boldOptions.querySelector('.bold_option_total')) return true
    return false
  }

  /**
   * Bold Options は非同期で .bold_options に注入されるため、
   * 既に入っていれば即同期、まだなら MutationObserver で待つ
   * アダプター見出しが無いまま注入が終わったらアコーディオンは出さない
   */
  function watchBoldOptions(root) {
    var form = root.closest('form') || document
    var observer = null

    function trySync() {
      if (syncAdapterChoices(root)) {
        if (observer) observer.disconnect()
        return true
      }
      if (isBoldOptionsSettled(form) && !findAdapterRadioGroup(form)) {
        if (observer) observer.disconnect()
        return true
      }
      return false
    }

    if (trySync()) return

    var boldOptions = form.querySelector('.bold_options')
    if (!boldOptions) return

    observer = new MutationObserver(trySync)
    observer.observe(boldOptions, { childList: true, subtree: true })

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
      BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', trySync)
    }
  }

  function setAccordionOpen(root, trigger, panel, isOpen) {
    root.classList.toggle('is-open', isOpen)
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    panel.hidden = !isOpen
  }

  /** 1つのアコーディオンルートを初期化する */
  function initAppleWatchAccordion(root) {
    // 二重初期化防止
    if (!root || root.dataset.appleWatchReady === 'true') return
    root.dataset.appleWatchReady = 'true'

    var trigger = root.querySelector('.js-apple-watch-accordion-trigger')
    var panel = root.querySelector('.js-apple-watch-accordion-panel')
    if (!trigger || !panel) return

    // 他サイズから遷移してきた場合は最初から開く
    if (shouldOpenAccordionFromQuery()) {
      setAccordionOpen(root, trigger, panel, true)
    }

    // アコーディオン開閉
    trigger.addEventListener('click', function () {
      setAccordionOpen(root, trigger, panel, !root.classList.contains('is-open'))
    })

    bindBeltChoices(root)
    // アダプター選択肢は Bold Options 連携で生成
    watchBoldOptions(root)

    // 同一 form のカート投入が連打で二重にならないようガード
    var form = root.closest('form')
    if (form) {
      guardFormSubmitOnce(form)
      watchUrushiCheck(form)
    }
  }

  /**
   * オプションタイトルに「バックル」「Dバックル」があるか
   */
  function hasBuckleOption(form) {
    var scope = form || document
    var titles = scope.querySelectorAll('.bold_option .bold_option_title')
    for (var i = 0; i < titles.length; i++) {
      var title = (titles[i].textContent || '').trim()
      if (BUCKLE_TITLE_RE.test(title)) return true
    }
    return false
  }

  /**
   * バックル系オプションがあるときだけ .bold_option_top / .option-d-buckle-note を表示する
   * @returns {boolean} 表示できた場合 true
   */
  function syncBuckleOptionTop(form) {
    if (!hasBuckleOption(form)) return false
    var scope = form || document
    var top = scope.querySelector('.bold_option_top')
    if (top) top.classList.add('is-ready')
    var note = scope.querySelector('.option-d-buckle-note')
    if (note) note.classList.add('is-ready')
    return true
  }

  /**
   * Bold Options 注入後に、バックル見出しの表示を確定する
   */
  function watchBuckleOptionTop(form) {
    if (!form || form.dataset.buckleTopWatching === 'true') return
    form.dataset.buckleTopWatching = 'true'

    var observer = null
    function trySync() {
      if (syncBuckleOptionTop(form)) {
        if (observer) observer.disconnect()
        return true
      }
      if (isBoldOptionsSettled(form)) {
        if (observer) observer.disconnect()
        return true
      }
      return false
    }

    if (trySync()) return

    var boldOptions = form.querySelector('.bold_options')
    if (!boldOptions) return

    observer = new MutationObserver(trySync)
    observer.observe(boldOptions, { childList: true, subtree: true })

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
      BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', trySync)
    }
  }

  function initAll() {
    document.querySelectorAll('.js-apple-watch-accordion').forEach(initAppleWatchAccordion)
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      guardFormSubmitOnce(form)
      watchUrushiCheck(form)
      watchBuckleOptionTop(form)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }
})()
